// extracted by mini-css-extract-plugin
module.exports = {"container":"LinksList_container__h0BBw","links":"LinksList_links__QBVgK","icon":"LinksList_icon__1105u","link":"LinksList_link__3CxNl"};